import Vue from 'vue'

const handles = new Set()

function toConstructor(Component) {
  if (typeof Component === 'function') return Component
  return Vue.extend(Component)
}

function isInsidePermanent(el) {
  return !!(el && typeof el.closest === 'function' && el.closest('[data-turbolinks-permanent]'))
}

function findHandle(target) {
  if (!target) return null
  if (handles.has(target)) return target

  for (const handle of handles) {
    if (handle.vm === target) return handle
    if (handle.el === target) return handle
    if (handle.vm && handle.vm.$el === target) return handle
  }

  const vm = target.__vue__
  if (vm) {
    for (const handle of handles) {
      if (handle.vm === vm) return handle
    }
  }

  return null
}

function destroyHandle(handle) {
  if (!handle || !handles.has(handle)) return

  handles.delete(handle)
  const vm = handle.vm
  const el = handle.el || (vm && vm.$el)

  if (vm && !vm._isDestroyed && typeof vm.$destroy === 'function') {
    vm.$destroy()
  }
  if (el && el.parentNode) el.remove()
}

export function mountVue(Component, { el, props = {}, on = {} } = {}) {
  const Ctor = toConstructor(Component)
  const vm = new Ctor({ el, propsData: props })

  Object.keys(on).forEach((event) => {
    const handler = on[event]
    if (typeof handler === 'function') vm.$on(event, handler)
  })

  const handle = {
    vm,
    el: vm.$el,
    unmount() {
      unmountVue(handle)
    }
  }
  handles.add(handle)
  return handle
}

export function unmountVue(handleOrEl) {
  const handle = findHandle(handleOrEl)
  if (handle) {
    destroyHandle(handle)
    return
  }

  const vm = handleOrEl && handleOrEl.__vue__
  if (vm && typeof vm.$destroy === 'function' && !vm._isDestroyed) vm.$destroy()
}

export function unmountVueIn(root = document) {
  for (const handle of [...handles]) {
    const el = handle.el || (handle.vm && handle.vm.$el)
    if (!el) {
      destroyHandle(handle)
      continue
    }
    if (isInsidePermanent(el)) continue
    if (root === document || root.contains(el)) destroyHandle(handle)
  }
}
